import {
  ClientRefFragment,
  ClientsDocument,
  ClientsQuery,
  withNewStandardListHook,
} from '@spotify/confidence-graphql';

export const useClients = withNewStandardListHook<
  ClientsQuery,
  ClientRefFragment,
  'clients'
>(ClientsDocument, 'clients', {
  typename: 'IamV1ListClientsResponse',
  fragmentName: 'ClientRef',
});
